import React, {useState, useEffect} from 'react'
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg"
import Pagination from 'react-js-pagination';
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import { useSelector, useDispatch } from 'react-redux';
import Select from "react-select"


export default function PaginationComponent(props) {

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [iswebMobile, setWebMobile] = useState();
    let { documentList, menuToggle} = useSelector((state) => ({
        documentList: state.documentReducer.document,
        menuToggle: state.commonReducer.menuToggle}));
    const paginglist = [{ "label": "5", "value": 5 }, { "label": "10", "value": 10 }, { "label": "20", "value": 20 }, { "label": "50", "value": 50 }]
    const paginglistDefault = [{ "label": "20", "value": 20 }]

    const [isMobile, setisMobile] = useState(false);
    const[isCancelMobile,setisCancelMobile]=useState(false);
    
    useEffect(()=> {

        const intervals = setInterval(() => {
            resize()
        }, 10);
        return () => clearInterval(intervals);
        
    }, []);

    
    const resize = () => {
      if (window.innerWidth < 850) { setisMobile(true) }
      else { setisMobile(false) }

      if (window.innerWidth < 400) {
        setWebMobile(true)
      } else {
        setWebMobile(false)
      }
      if (window.innerWidth < 315) {
        setisCancelMobile(true)
      } else {
        setisCancelMobile(false)
      }
  }

  useEffect(()=>{
    setCurrentPage(1); 
   },[props.reset])

    /////////////////////////////////// pagination /////////////////////////////////////////
    const handlePageChange=(pageNumber)=> {
      setCurrentPage(pageNumber);
      callPropFunction(pageNumber, perPage);
    
    }
    const find = (e) => {
      const perPageValue = parseInt(e.value);
      const selectedPage = 1;
      setPerPage(perPageValue);
      setCurrentPage(selectedPage)
      callPropFunction(selectedPage, perPageValue);
    };

    // const find = e => {
    //     const perPageValue = parseInt(e.value);
    //     setPerPage(perPageValue);
    //     callPropFunction(currentPage, perPageValue);
    //   };
      
    //   const previousPage = () => {
    //     const newCurrentPage = currentPage - 1;
    //     setCurrentPage(newCurrentPage);
    //     callPropFunction(newCurrentPage, perPage);
    //   };
      
    //   const nextPage = () => {
    //     const newCurrentPage = currentPage + 1;
    //     setCurrentPage(newCurrentPage);
    //     callPropFunction(newCurrentPage, perPage);
    //   };
      
      const callPropFunction = (currentPageValue, perPageValue) => {
        props.fetchPagination(currentPageValue, perPageValue);
      };

  return (
    <div
    className={`${
      isMobile? "common-mobilesubmenu mobile-pagination"
        : menuToggle? "common-submenu sidemenu-pagination": "common-submenu web-pagination"} pb-2 pt-2`}>

    <table width="100%">
      <tbody>
        <tr>
          <td width="8%" className="p-3">
            <div className={`${ iswebMobile ?"mobilePageSelect":"webpageSelect"}`}>
              <Select
                options={paginglist}
                defaultValue={paginglistDefault || "Select"}
                classNamePrefix="paging"
                isSearchable={false}
                menuPlacement={"top"}
                menuPosition={"fixed"}
                onChange={(e) => find(e)}
              />
            </div>
          </td>
          <td width="92%" className={`text-end ${isCancelMobile?"pagination-padd":"p-3"}`}>
            {isMobile?
               <Pagination
               prevPageText={<>{" "}<img src={LeftArrowIcon} /></>}
               nextPageText={<><img src={RightArrowIcon} />{" "}</>}
               linkClassNext="nextArrow"
               linkClassPrev="prevArrow"
               itemClass={`page-item`}
               linkClass="page-link"
               pageRangeDisplayed={1}
               onChange={e => handlePageChange(e)}
               activePage={currentPage}
               totalItemsCount={props.pageCount}
               itemsCountPerPage={perPage}
               />:
          <Pagination
            prevPageText={<>{" "}<img src={LeftArrowIcon} /></>}
            nextPageText={<><img src={RightArrowIcon} />{" "}</>}
            linkClassNext="nextArrow"
            linkClassPrev="prevArrow"
            itemClass={`page-item`}
            linkClass="page-link"
            pageRangeDisplayed={4}
            onChange={e => handlePageChange(e)}
            activePage={currentPage}
            totalItemsCount={props.pageCount}
            itemsCountPerPage={perPage}
            />}
       </td>
        </tr>
      </tbody>
    </table>
  
  </div>

  
  )
}
